import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { LoggerService } from '../service/logger-service/logger.service';
import { Art57Section } from '../ui/Art57Section/Art57Section';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

   constructor(
      private injector: Injector
   ) {}

   handleError(error: any) {
      this.injector.get(LoggerService).err(error);
      this.injector.get(Art57Section).removeIsLoading();
   }
}